<!-- REF: 41.2 -->
<template>
  <gv-modal
    data-theme="mobile"
    :modal="modal"
    size="custom"
    :custom-size-class="tw`w-[calc(100vw-2rem)] xs:w-[312px] p-6`"
    layout="flex-col"
    :close-on-click-outside="false"
    :border-radius="tw`rounded-2xl`"
    :aria-labelledby="headingId"
  >
    <template #header>
      <div></div>
    </template>

    <div class="flex flex-col gap-6">
      <div class="flex flex-col gap-4">
        <mep-type is="h2" :id="headingId" variant="feature-large">Email your emergency plan to yourself or others.</mep-type>
        <mep-text-input v-model="email" :error="fieldErrors?.email" label="Email address" />
      </div>
      <div class="flex flex-row gap-2">
        <mep-button text="Cancel" variant="text" class="flex-1 px-4 py-2" @click="modal.setClosed" />
        <mep-button
          text="Send"
          variant="primary"
          class="flex-1 px-4 py-2"
          :disabled="!isValid"
          :loading="myEmergencyPlanStore.isSendingPdfEmail"
          @click="onSubmit"
        />
      </div>
    </div>
  </gv-modal>
</template>

<script lang="ts" setup>
import { tw } from '@/common';
import { toTypedSchema } from '@vee-validate/zod';
import { useForm } from 'vee-validate';
import { computed, inject, useId } from 'vue';
import * as Symbols from '@/common/constants/symbols';
import { mepEmailModalSchema } from '@/features';
import { useMyEmergencyPlanStore } from '@/features/my-emergency-plan/presentation/bloc/my-emergency-plan-bloc';

const headingId = useId();
const myEmergencyPlanStore = useMyEmergencyPlanStore();

const { modal } = {
  modal: inject(Symbols.MyEmergencyPlanSendPlanModal)!,
};

const { defineField } = useForm({ validationSchema: toTypedSchema(mepEmailModalSchema) });

const [email] = defineField('email');

const fieldErrors = computed(() => {
  const validationResult = mepEmailModalSchema.safeParse({ email: email.value }).error?.flatten().fieldErrors;
  return validationResult;
});

const isValid = computed(() => {
  return !fieldErrors.value;
});

const onSubmit = async () => {
  if (!email.value) return;
  const result = await myEmergencyPlanStore.sendPlanByEmail(email.value);

  if (result) {
    modal.setClosed();
  }
};
</script>
